import { Combobox } from "@/components/ui/combobox";

interface HeaderTypeSelectProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

const headerTypes = [
    { value: "String", label: "String" },
    { value: "Number", label: "Number" },
    { value: "Boolean", label: "Boolean" },
    { value: "Object", label: "Object" }
];

export function HeaderTypeSelect({ value, onChange, disabled = false }: HeaderTypeSelectProps) {
    return (
        <Combobox
            options={headerTypes}
            value={value}
            onValueChange={onChange}
            placeholder="Select type"
            className="w-[120px]"
            disabled={disabled}
        />
    );
}
